/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $FullPatientCalendar = {
    properties: {
        patientCalendar: {
    type: 'PatientCalendar',
    isRequired: true,
},
        eventType: {
    type: 'CalendarEventType',
    isRequired: true,
},
        createdBy: {
    type: 'IdName',
    isRequired: true,
},
    },
};